import { render } from "./leftblock.vue?vue&type=template&id=1ca2f38a&scoped=true"
import script from "./leftblock.vue?vue&type=script&lang=js"
export * from "./leftblock.vue?vue&type=script&lang=js"

import "./leftblock.vue?vue&type=style&index=0&id=1ca2f38a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca2f38a"]])

export default __exports__